import loadable from '@loadable/component';

// 懒加载组件
const DeliveryReturnManagement = loadable(() => import('../supOrder/operationDeliveryReturnQuery/OperationDeliveryReturnQuery'));
const OrderManagement = loadable(() => import('./orderManagement/OrderManagement'));
const DeliveryManagement = loadable(() => import('./deliveryManagement/DeliveryManagement'));
const DeliveryModify = loadable(() => import('./deliveryManagement/deliveryModify/DeliveryModify'));
const DeliveryInvoiceInputManagement = loadable(() => import('./deliveryInvoiceInputManagement/DeliveryInvoiceInputManagement'));
const DeliveryInvoiceManagement = loadable(() => import('./deliveryInvoiceManagement/DeliveryInvoiceManagement'));
const OrderDetailQuery = loadable(() => import('./orderDetailQuery/OrderDetailQuery'));
const DeliveryDetailQuery = loadable(() => import('./deliveryDetailQuery/DeliveryDetailQuery'));

export const subRoutes = [
  {
    // M253105 【SAAS】供应商：高值退货单确认
    path: '/DeliveryReturnManagement',
    component: DeliveryReturnManagement
  },
  {
    // M253104 【SAAS】供应商：普耗退货单确认
    path: '/DeliveryReturnManagement',
    component: DeliveryReturnManagement
  },
  {
    // M253101【SAAS】供应商：订单查询响应
    path: '/OrderManagement',
    component: OrderManagement
  },
  {
    // M253102【SAAS】供应商：普耗发货单管理
    path: '/DeliveryManagement',
    component: DeliveryManagement
  },
  {
    // 耗材发货单明细修改
    path: '/DeliveryModify',
    component: DeliveryModify
  },
  {
    // M253106 【SAAS】供应商：进项票管理
    path: '/DeliveryInvoiceInputManagement',
    component: DeliveryInvoiceInputManagement
  },
  {
    // M253107 【SAAS】供应商：发货单发票管理
    path: '/DeliveryInvoiceManagement',
    component: DeliveryInvoiceManagement
  },
  {
    // M253110【SAAS】供应商：订单明细查询
    path: '/OrderDetailQuery',
    component: OrderDetailQuery
  },
  {
    // M253111【SAAS】供应商：发货明细查询
    path: '/DeliveryDetailQuery',
    component: DeliveryDetailQuery
  }
];
